import ErrorText from '@atoms/Typographies/Texts/ErrorText';
import React from 'react';
import { Form } from 'react-bootstrap';
import styled from 'styled-components';


type Props = {
    register: any;
    controlId: string;
    placeholder?: string;
    width?: string | number | undefined;
    error?: any;
};

const getWidthForStyle = (width: string | number | undefined) => {
    if (typeof width === 'number') return width;
    if (typeof width === 'string') {
        switch (width) {
            case 'small':
                return 140;
            case 'middle':
                return 280;
            case 'large':
                return 400;
            default:
                return 280;
        }
    }
    return 280;
}


const InputText = (props: Props) => {
    const { controlId, placeholder, register, error, width } = props;
    const inputMaxWidth = getWidthForStyle(width);

    return (
        <Form.Group controlId={controlId}>
            <InputSizeSWithStyled maxWidth={inputMaxWidth}>
                <Form.Control
                    size='sm'
                    placeholder={placeholder}
                    {...register(controlId)}
                />
            </InputSizeSWithStyled>
            {error && <ErrorText>{error.message}</ErrorText>}
        </Form.Group>
    )
}
type InputSizeSWithStyledType = {
    maxWidth: number;
}

const InputSizeSWithStyled = styled.span<InputSizeSWithStyledType>`
    max-width:  ${({ maxWidth }) => maxWidth}px;
    display: block;
`;

export default InputText;